import { FLAT_RATE_PLANS } from "@common/flatRateBilling";
import { UserWorkspaceRole } from "@common/userWorkspaceRoles";

/**
 * The role a user effectively acts under in a workspace, once the workspace's
 * plan is taken into account. On a Read-only plan every stored role is
 * overlaid to `VIEW_ONLY` — the stored assignment is never rewritten (D11/D12),
 * this only changes what enforcement sees.
 *
 * A `null` stored role means "no assignment" and stays `null`: "no role" must
 * never read as View-only (that would turn a 404 into a 403). Shared by the
 * backend `ViewOnlyAccessService` and the frontend `useActiveWorkspaceRole` so
 * the two enforcement surfaces cannot drift (D13).
 */
export function effectiveWorkspaceRole(params: {
    storedRole: UserWorkspaceRole | null;
    plan: FLAT_RATE_PLANS | null;
}): UserWorkspaceRole | null {
    if (params.storedRole === null) {
        return null;
    }
    if (params.plan === FLAT_RATE_PLANS.READ_ONLY) {
        return UserWorkspaceRole.VIEW_ONLY;
    }
    return params.storedRole;
}
